module.exports = __webpack_public_path__ + "static/media/splash.822396ca.psd";